import { Col, Form, FormInstance, Input, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { ShopOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { convertPrice } from '../../../utils/display';

interface IProps {
  form: FormInstance;
}

const ProductSummary: React.FC<IProps> = () => {
  const { order } = useSelector((state: any) => state);
  return (
    <>
      <div>
        <div
          style={{
            padding: '8px',
            fontSize: '18px',
            color: '#fff',
            backgroundColor: '#045de9',
          }}
        >
          <ShopOutlined /> &nbsp;
          {order?.shop?.name}
        </div>

        {order?.products?.map((item: any) => {
          const userProduct = item.product['_id'];
          const product = userProduct.product;
          return (
            <Row
              key={item._id}
              style={{
                background: '#fff',
                borderRadius: '5px',
                padding: '4px',
                marginBottom: '4px',
              }}
            >
              <Col>
                <img width={80} alt="" src={product.files[0]} />
              </Col>
              <Col flex="auto">
                <div style={{ padding: '4px' }}>
                  <b>{product.productName}</b>
                </div>
                <div style={{ padding: '4px' }}>
                  ราคาต่อชิ้น{' '}
                  <span style={{ color: '#045de9' }}>
                    {convertPrice(userProduct.memberPrice)}
                  </span>{' '}
                  บาท
                </div>
                <Row
                  justify="space-between"
                  style={{ padding: '4px' }}
                >
                  <Col>จำนวน {item.amount} ชิ้น</Col>
                  <Col style={{ color: '#045de9' }}>
                    รวม{' '}
                    {convertPrice(
                      item.amount * userProduct.memberPrice
                    )}{' '}
                    บาท
                  </Col>
                </Row>
              </Col>
            </Row>
          );
        })}

        <Row
          justify="space-between"
          style={{
            padding: '4px',
            fontSize: '16px',
            color: '#fff',
            backgroundColor: 'cornflowerblue',
          }}
        >
          <Col>ค่าสินค้ารวม</Col>
          <Col>{convertPrice(order.totalPrice)} บาท</Col>
        </Row>
      </div>
    </>
  );
};

export default ProductSummary;
